import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=738c16b0&scoped=true&"
import script from "./ArticlePage.vue?vue&type=script&lang=js&"
export * from "./ArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c16b0",
  null
  
)

export default component.exports